import { ca } from '@cian/analytics';

export const trackBannerShow = (label: 'CpdConsultationTextLink' | 'CpdConsultationBanner') => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHome',
    action: 'Show',
    label,
  });
};

export const trackBannerClick = (label: 'CpdConsultationTextLink' | 'CpdConsultationBanner') => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHome',
    action: 'Click_sopr',
    label,
  });
};
